var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import MuiLinearProgress from '@mui/material/LinearProgress';
import styled from '@emotion/styled';
export var ProgressBarLoader = styled(MuiLinearProgress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px;\n  height: 15px;\n"], ["\n  margin: 20px;\n  height: 15px;\n"])));
var templateObject_1;
